export default __webpack_public_path__ + "static/blog2-67f994b96593565ea08a1b41403b2d12.jpg";